import {WithChildren} from '_metronic/helpers'
import {CSSProperties, FC, useMemo} from 'react'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  btnType?: 'primary' | 'default' | 'transparent' | 'black'
}

const Button: FC<Props & WithChildren> = ({
  btnType = 'default',
  style,
  className = '',
  onClick = () => {},
  children,
  disabled = false,
  ...rest
}) => {
  const btnStyle = useMemo<CSSProperties>(() => {
    switch (btnType) {
      case 'primary':
        return {
          backgroundColor: '#0E9F6E',
          border: '1px solid transparent',
          color: 'white',
        }
      case 'default':
        return {
          backgroundColor: 'white',
          border: '1px solid #D1D5DB',
          color: 'black',
        }
      case 'transparent':
        return {
          backgroundColor: 'transparent',
          border: 'none',
          color: 'black',
        }
      case 'black':
        return {
          backgroundColor: 'black',
          border: '1px solid transparent',
          color: 'white',
        }
      default:
        return {}
    }
  }, [btnType])

  const onMouseEnterBackgroundColorStyle = useMemo(() => {
    switch (btnType) {
      case 'primary':
        return '#148363'
      case 'default':
        return '#F1F1F2'
      case 'transparent':
        return '#F0F0F0'
      case 'black':
        return '#333333'
      default:
        return ''
    }
  }, [btnType])

  const onMouseLeaveBackgroundColorStyle = useMemo(() => {
    switch (btnType) {
      case 'primary':
        return '#0E9F6E'
      case 'default':
        return 'white'
      case 'transparent':
        return 'transparent'
      case 'black':
        return 'black'
      default:
        return ''
    }
  }, [btnType])

  return (
    <button
      className={`btn btn-sm fs-6 d-flex align-items-center justify-content-center ${className}`}
      style={{
        ...btnStyle,
        height: '40px',
        opacity: `${disabled ? '0.5' : '1'}`,
        ...style,
      }}
      onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
        (e.currentTarget.style.backgroundColor = onMouseEnterBackgroundColorStyle)
      }
      onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
        (e.currentTarget.style.backgroundColor = onMouseLeaveBackgroundColorStyle)
      }
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
